import React, { useState, useEffect, useRef } from 'react';
import '../../App.css';

import logo from '../../assets/images/logo.png';
import email from '../../assets/images/mail.png'
import view from '../../assets/images/view.png';
import hide from '../../assets/images/view_show.png';
import Show from '../../assets/images/view_show.png'
import { Modal, Col, Form, Button } from "react-bootstrap";

import { withoutRFSToken } from '../../Services/axios.js';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { AddSession } from '../../useAuth/SessionExtract.js';

const LoginPage = () => {
    // localStorage.clear();

    const [showHide, setShowHide] = useState(false);
    const [otp, setOtp] = useState('');
    const [otpModal, setOtpModal] = useState(false);
    const history = useHistory()
    const initial = { device_type: 'web' }
    // const [formData, setFormData] = useState(initial);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [remember, setRemember] = useState(false);
    const hideToggle = () => {
        setShowHide(!showHide);
    }

    // const formChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData((prevFormData) => ({
    //         ...prevFormData,
    //         [name]: value,
    //     }));
    // }

    const validateFormData = () => {
        let isValid = true;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        const validateEmail = (email) => {
            return emailRegex.test(email);
        };
        if (!validateEmail(username)) {
            // console.log('Invalid email address');
            toast.error('Invalid email address');
            isValid = false;
        } else if (!password) {
            // console.log('Text input is required');
            toast.error('Please enter password');
            isValid = false;
        } else {
            return isValid;
        }
    }

    const handleRedeirect = (data) => {
        localStorage.clear();
        const setIfHasValue = (key, value) => {
            if (value !== null && value !== undefined && value !== "") {
                localStorage.setItem(key, value);
            }
        };
        if (data.airlinetoken && data.user_type && data.org_type) {
            setIfHasValue('User', data.user_name);
            setIfHasValue('UserID', data.user_id);
            setIfHasValue('UserType', data.user_type);
            setIfHasValue('UserNumber', data.user_number);
            setIfHasValue('LoginUser', data.login_user_type);
            setIfHasValue('OrgType', data.org_type);
            setIfHasValue('OrgName', data.org_name);
            setIfHasValue('Email', data.email_id);
            setIfHasValue('GoBack', data.back_url);
            // setIfHasValue('LogOut', logOutPath);
            // setIfHasValue('login_from', loginFrom);
            // setIfHasValue('truck_id', truckId);
            // setIfHasValue('CEmail', recEmail);
            // setIfHasValue('person', person);
            // setIfHasValue('key', key);
            setIfHasValue('orgLogo', data.org_logo);

            if (data.user_type === 'SA') {
                localStorage.setItem('SAToken', data.airlinetoken);
                window.location.href = '/SuperAdmin';
            } else {
                localStorage.setItem('airlinetoken', data.airlinetoken);
                window.location.href = '/Dashboard';
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateFormData()) {
            try {
                const res = await withoutRFSToken.post('web-login', { device_type: 'web', email: username, password: password })
                    .then(function (res) {
                        // console.log('res', res)
                        const resCode = res.data.response_code;
                        if (resCode === 200) {
                            const innerData = res.data.response_data;
                            // handleRedeirect(innerData)
                            // sessionStorage.setItem('auth', JSON.stringify(innerData));
                            let addUrl = {}
                            if (innerData?.user_type === 'SA') {
                                window.location.replace('/SuperAdmin')
                                addUrl = {...innerData, loc: '/SuperAdmin'}
                                
                                // sessionStorage.setItem('loc', '/SuperAdmin');
                                // history.push('/SuperAdmin')
                            } else {
                                // history.push('/Dashboard')
                                if (innerData?.org_type === 'T') {
                                    // window.location.replace('/Trucker')
                                    addUrl = {...innerData, loc: '/Trucker'}
                                    
                                } else {
                                    window.location.replace('/Dashboard')
                                    // sessionStorage.setItem('loc', '/SuperAdmin');
                                    addUrl = {...innerData, loc: '/Dashboard'}
                                }
                                
                            }
                            AddSession('__A-', addUrl)
                            // setFormData(initial)
                        } else if (resCode === 201) {
                            // toast.error(res.data.response_msg);
                            setOtpModal(true)
                        } else {
                            toast.error(res.data.response_msg);
                        }
                    });

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    }
    const handleOtpSubmit = async () => {
        if (otp) {
            const payload = { device_type: 'web', email: username, password: password, otp: otp }
            try {
                const res = await withoutRFSToken.post('otp-verification', payload)
                    .then(function (res) {
                        const resCode = res.data.response_code;
                        if (resCode === 200) {
                            const innerData = res.data.response_data;
                            handleRedeirect(innerData)
                            setOtpModal(false);
                            // setFormData(initial)
                            // setOtp('')
                        } else {
                            toast.error(res.data.response_msg);
                        }
                    });

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    }

    return (
        <>
            <section className="vh-100">
                <div className="container-fluid">
                    <div className="row d-flex align-items-center vh-100">
                        <div className="loginform-left vh-100 justify-content-around align-items-center d-flex">
                            <span><img src={logo} /></span>
                        </div>
                        <div className="logform">
                            <h2>Sign in to Cargohub</h2>
                            <p>Welcome Back ! Please details</p>

                            <form autoComplete="on" onSubmit={handleSubmit}>
                                <div className="form-outline mb-4">
                                    <input
                                        type="email"
                                        id="form3Example3"
                                        className="form-control"
                                        name='username'
                                        placeholder=""
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        autoComplete="username"
                                    />
                                    <label className="form-label" htmlFor="form3Example3">Email address</label>
                                </div>
                                <div className="form-outline mb-3">
                                    <input
                                        type={showHide ? 'text' : 'password'}
                                        id="form3Example4"
                                        className="form-control"
                                        name='password'
                                        placeholder=""
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        autoComplete="current-password"
                                    />
                                    <label className="form-label" htmlFor="form3Example4">Password</label>
                                    <img src={showHide ? hide : view} className="passwrd_view" onClick={hideToggle} />
                                </div>
                                <div className="d-flex align-items-center">
                                    <div className="form-check mb-0">
                                        <input
                                            className="form-check-input me-2"
                                            type="checkbox"
                                            value=""
                                            id="form2Example3"
                                            checked={remember}
                                            onChange={() => setRemember(!remember)}
                                        />
                                        <label className="form-check-label" htmlFor="form2Example3">
                                            Remember me
                                        </label>
                                    </div>
                                    <a href="/forgotpassword" className="text-forgot">Forgot password?</a>
                                </div>
                                <div className="text-center text-lg-start mt-4 pt-2">
                                    <button type="submit" className="btn btn-primary btn-lg"
                                        style={{ paddingLeft: 1.5 + 'rem', paddingRight: 1.5 + 'rem' }} >Login Now</button>
                                    {/* <p className="small mt-2 pt-1 mb-0">Don't have an account? <a href="/registerPage"
                                    className="link-danger">Create Now</a></p> */}
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </section>
            <Modal show={otpModal} className="addfrom change_type" centered> {/* onHide={closeConfirm} */}
                <Modal.Header closeButton onClick={() => setOtpModal(false)}></Modal.Header>
                <Modal.Body>
                    <h3>Varification</h3>
                    <p>Please enter your OTP here</p>
                    <Form.Control type="text" onChange={(e) => setOtp(e.target.value)} name='otp' placeholder="" value={otp} />
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex w-50 mx-auto are_bottom">
                        <Button variant="primary" onClick={handleOtpSubmit}> Submit </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default LoginPage;